<template>
  <Loader v-if="this.$store.state.isLoading" />
  <Modal
    v-if="modalActive"
    :modalMessage="modalMessage"
    @close-modal="handleClose"
  />
  <div class="profile" v-if="!this.$store.state.isLoading">
    <p class="text-center" style="font-size: 32px">Account Settings</p>
    <div class="user-form">
      <form @submit.prevent="onSave">
        <div class="user-avatar">{{ getInitials }}</div>
        <div class="auth-field">
          <i class="fas fa-user auth-icon"></i>
          <input
            type="text"
            class="auth-input"
            placeholder="Name"
            v-model="userDetails.name"
          />
        </div>
        <div class="auth-field">
          <i class="fas fa-user auth-icon"></i>
          <input
            disabled
            type="email"
            class="auth-input"
            placeholder="Email"
            v-model="userDetails.email"
          />
        </div>
        <button type="submit" class="auth-button">Save Changes</button>
      </form>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Modal from "../components/Modal.vue";
import Loader from "../components/Loader.vue";
export default {
  name: "Profile",
  components: {
    Modal,
    Loader,
  },
  data() {
    return {
      modalMessage: "Changes are saved!",
      modalActive: false,
    };
  },
  computed: {
    userDetails() {
      return this.$store.state.userProfile;
    },
    getInitials() {
      if (this.$store.state.userProfile.name) {
        return this.$store.state.userProfile.name[0];
      } else {
        return "?";
      }
    },
  },
  methods: {
    handleClose() {
      this.modalActive = false;
    },
    async onSave() {
      await this.$store.dispatch("updateUserDetails", this.userDetails);
      this.modalActive = true;
    },
  },
};
</script>

<style scoped>
.profile {
  min-width: 100vw;
  padding: 20px 25px 60px 25px;
}
.user-form {
  text-align: center;
  border-radius: 10px;
  padding: 32px;
  background-color: #f1f1f1;
  display: flex;
  flex-direction: column;
  max-width: 700px;
  margin: 32px auto;
}
.user-avatar {
  font-size: 24px;
  margin: auto;
  width: 60px;
  height: 60px;
  display: flex;
  background-color: #303030;
  color: white;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin-bottom: 30px;
}
</style>
